const ButtonTextIcon = ({ icon, title, ...rest }) => {
	return (
		<button {...rest}>
			<span>
				{icon}
				<span>{title}</span>
			</span>
		</button>
	);
};

export default ButtonTextIcon;
